var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("visualizar-cadastro-coletivo", {
        attrs: {
          cadastro: _vm.cadastroColetivo,
          showInformacoesAnalise: false,
          isRetificacao: _vm.isRetificacao
        }
      }),
      _vm.oficiosExists
        ? _c(
            "div",
            { staticClass: "wrap-collabsible" },
            [
              _c("divider", { attrs: { label: "Documentos Tramitados" } }),
              _c("table-generica", {
                attrs: {
                  dados: _vm.documentosAssinados,
                  colunas: _vm.colunas,
                  botoesAcao: _vm.botoesAcao
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.despachosFormatados.length && !_vm.isRetificacao
        ? _c(
            "div",
            { staticClass: "wrap-collabsible" },
            [
              _c("divider", { attrs: { label: "Histórico de despachos" } }),
              _c(
                "el-collapse",
                _vm._l(_vm.despachosFormatados, function(despacho) {
                  return _c(
                    "el-collapse-item",
                    {
                      key: despacho.dataCriacao,
                      attrs: {
                        title:
                          "Análise " + _vm.setoresFormatado[despacho.setor],
                        name: despacho.dataCriacao
                      }
                    },
                    [
                      _c("Informacoes-analise", {
                        attrs: {
                          responsavel: despacho.usuario.pessoa.nomeRazaoSocial,
                          cargo: despacho.perfil,
                          data: despacho.dataCriacao
                        }
                      }),
                      _c(
                        "div",
                        [
                          _c("divider", { attrs: { label: "Despacho" } }),
                          _c("div", {
                            staticClass: "mt-1 padding-info-analise"
                          }),
                          _c("el-row", [
                            _c("p", {
                              staticClass: "input",
                              domProps: { innerHTML: _vm._s(despacho.texto) }
                            })
                          ])
                        ],
                        1
                      ),
                      despacho.documento
                        ? _c(
                            "div",
                            [
                              _c("divider", { attrs: { label: "Anexo" } }),
                              despacho.documento
                                ? _c(
                                    "div",
                                    { staticClass: "arquivos" },
                                    [
                                      _c("app-download-arquivo", {
                                        attrs: { arquivo: despacho.documento },
                                        on: {
                                          download: function($event) {
                                            return _vm.download(
                                              despacho.documento
                                            )
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                }),
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a218a4de", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a218a4de","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/arrecadacao/components/Despachos.vue
// module id = null
// module chunks = 